import React from 'react'
import { Avatar } from 'antd'
import men from '../../../assets/images/profile/men.png'
import women from '../../../assets/images/profile/women.png'

class AvatarProfile extends React.PureComponent {
	render() {
		const { imgProfile, typeFile, showImage } = this.props
		// console.log('imgProfile',imgProfile)
		// let test = { 'data:'+typeFile+';base64,'+imgProfile }
		var imgStylr = {
			backgroundImage: `url(data:${typeFile};base64,${imgProfile})`,
			width:"100%",
			height:"100%"
		  };

		return (
			<>
				{
					// <Avatar src={men} style={{ width:'100%',height:'auto' }}/>

					showImage  == 'Avatar' &&
						<Avatar src={imgProfile} style={{ width:'100%',height:'auto' }}/>
					||
						<div className="custom-img-profile">
							<div style={imgStylr}></div>
						</div>
				}
			</>
		)
	}
}

export default AvatarProfile
